import React from 'react';
import Button from '@mui/material/Button';
import { Box, TextField, Typography } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CloseIcon from '@mui/icons-material/Close';
// import AreYouSureModal from '../../../components/AreYouSureModal';


function CourseMemoButtonModal({
    course,
    colors, 
    handlePopOverClose,
    enqueueSnackbar,
    socketConnected,
    socket,
}) {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        maxHeight: '80%',
        overflowY: 'auto',
        bgcolor: colors.primary[600],
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    // const [areYouSureModalOpen, setAreYouSureModalOpen] = React.useState(false);
    
    const [memo, setMemo] = React.useState(course && course.course_memo_2 ? course.course_memo_2 : "");

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); handlePopOverClose(); };

    React.useEffect(() => {
        if (course && course.course_memo_2) {
            setMemo(course.course_memo_2);
        }
    }, [course]);

    async function handleSave() {
        if (!socketConnected) {
            enqueueSnackbar("Error: Cannot save the changes. Please try again.", { variant: "error" });
            return;
        }

        try {
            // emit to server
            socket.emit("put.CourseMemo2", {
                course_id: course.id,
                memo: memo,
            });
        } catch (error) {
            console.error(error);
            enqueueSnackbar("Error: Cannot save the changes. Please try again.", { variant: "error" });
            return;
        }

        handleClose();
    };

    const getCourseTitle = (course) => {
        let title = "";
        if (course.code && course.code !== "") {
            title = "(" + course.code + ") ";
        }

        title += course.course_title;

        return title;
    };

    return (
        <>
            <Button 
                onClick={handleOpen} 
                sx={{ 
                    p: 1, 
                    width: "100%",
                    bgcolor: colors.purpleAccent[900],
                    borderRadius: "0px",
                    '&:hover': {
                        bgcolor: colors.purpleAccent[800],
                    },
                }}
            >
                Comments
            </Button>
            <Modal
                aria-labelledby="attendance-modal"
                aria-describedby="attendance-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography variant="h4" color={colors.primary[450]}>
                            Comments for {getCourseTitle(course)}
                        </Typography>
                        <CloseIcon sx={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }} onClick={handleClose} />
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", mt: 2 }}>
                            <TextField
                                label="Comments"
                                multiline
                                rows={10}
                                variant="outlined"
                                value={memo}
                                onChange={(e) => setMemo(e.target.value)}
                                sx={{ width: 600, mt: 2 }}
                            />
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 2,
                                mt: 2,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ width: 200, mt: 2 }}
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                            {/* <AreYouSureModal
                                colors={colors}
                                open={areYouSureModalOpen}
                                setOpen={setAreYouSureModalOpen}
                                title="Are you sure?"
                                message="Are you sure you want to save the changes?"
                                onConfirm={handleSave}
                            /> */}
                            <Button
                                variant="contained"
                                color="error"
                                sx={{ width: 200, mt: 2 }}
                                onClick={handleClose}
                            >
                                Close
                            </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </>
    )
}

export default CourseMemoButtonModal;